import Keycloak from "keycloak-js";

export function createKeycloak(url, realm, clientId) {
    return new Keycloak({
        url,
        realm,
        clientId
    });
}

export function initKeycloak(keycloak) {
    return keycloak.init({
        onLoad: "check-sso",
        flow: "standard",
        pkceMethod: "S256",
        checkLoginIframe: false
    }).catch((error) => {
        console.error("Keycloak initialization failed", error);
        return false;
    });
}

export function keycloakToken(keycloak) {
    return keycloak.token ?? null;
}

export function refreshKeycloakToken(keycloak, minValidity) {
    return keycloak.updateToken(minValidity);
}

export function loginKeycloak(keycloak, redirectUri) {
    return keycloak.login({
        redirectUri
    });
}

export function logoutKeycloak(keycloak, redirectUri) {
    return keycloak.logout({
        redirectUri
    });
}

export function keycloakUsername(keycloak) {
    return keycloak.tokenParsed?.preferred_username ?? null;
}

export function keycloakEmail(keycloak) {
    return keycloak.tokenParsed?.email ?? null;
}

export function keycloakPrimaryRole(keycloak) {
    const roles = keycloak.tokenParsed?.realm_access?.roles ?? [];

    if (roles.includes("ADMIN")) {
        return "ADMIN";
    }

    if (roles.includes("WASH_OWNER")) {
        return "WASH_OWNER";
    }

    if (roles.includes("USER")) {
        return "USER";
    }

    return null;
}

export function checkKeycloakAvailability(url, realm) {
    return fetch(
        `${url}/realms/${realm}`,
        {
            method: "GET",
            mode: "no-cors",
            cache: "no-store"
        }
    )
        .then(() => true)
        .catch(() => false);
}

export function webConfigValue(name) {
    return globalThis.WASHMIO_CONFIG?.[name] ?? null;
}
